import { Manager } from '@/domain/mitarbeiter/features/anlageassistent/entities/Manager';
import { GET_MANAGER } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useManager/graphql/queries';
import {
  Mitarbeiter_GetManagerByStandortIdQuery,
  Mitarbeiter_GetManagerByStandortIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

export function useManager(standortId: string): { manager: Manager[] } {
  const result = useSuspenseQuery<
    Mitarbeiter_GetManagerByStandortIdQuery,
    Mitarbeiter_GetManagerByStandortIdQueryVariables
  >(GET_MANAGER, {
    variables: { standortId },
  });

  if (result.error) {
    Sentry.captureException(result.error);
    return { manager: [] };
  }

  return {
    manager: result.data.mitarbeiter_getAllManagerByStandortId.map(
      (m) =>
        new Manager({ id: m.id, vorname: m.vorname, nachname: m.nachname }),
    ),
  };
}
